module.exports = __webpack_public_path__ + "img/logo2000.58ccc1fd.svg";